import "antd/es/form/style";
import _Form from "antd/es/form";
import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import "antd/es/grid/style";
import _Grid from "antd/es/grid";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useContext, useEffect, useReducer, useRef } from 'react';
import HStep from '../hstep';
import { calcNamePath, getRuleValidation, calcShouldRender } from '../../utils/form-utils';
import FormContext from '../../form-context';
import StepContext from '../../form-step-context';
import './style/index.less';
import invariant from 'invariant';
import Confirmation from '../../confirmation';
import { LocaleContext } from '../../locale';
import Typography from '../../typography';
import Button from '../../button';
import Radio from '../../radio';
import { SuccessFilled } from 'iglooicon';
import classNames from 'classnames';
var useBreakpoint = _Grid.useBreakpoint;

var HSteps = function HSteps(_ref) {
  var _renderElements$curre2, _renderElements$curre3;

  var parentName = _ref.parentName,
      _ref$config = _ref.config,
      _ref$config$elements = _ref$config.elements,
      elements = _ref$config$elements === void 0 ? [] : _ref$config$elements,
      _ref$config$currentSt = _ref$config.currentStep,
      currentStep = _ref$config$currentSt === void 0 ? 0 : _ref$config$currentSt,
      subscribedFields = _ref$config.subscribedFields,
      onEdit = _ref$config.onEdit,
      confirmations = _ref$config.confirmations,
      description = _ref$config.description,
      _ref$config$withRevie = _ref$config.withReview,
      withReview = _ref$config$withRevie === void 0 ? true : _ref$config$withRevie,
      name = _ref$config.name;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      last = _useState4[0],
      setLast = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      shouldScroll = _useState6[0],
      setShouldScroll = _useState6[1];

  var _useReducer = useReducer(function (r) {
    return r + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _ = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  var sections = useRef(new Map());

  var _useContext = useContext(FormContext),
      form = _useContext.form,
      registerDependencies = _useContext.registerDependencies,
      submitText = _useContext.submitText,
      submitting = _useContext.submitting,
      showSubmitButton = _useContext.showSubmitButton,
      getRuleValidationApi = _useContext.getRuleValidationApi;

  var _useContext2 = useContext(LocaleContext),
      formatMessage = _useContext2.formatMessage,
      currentLang = _useContext2.currentLang;

  useEffect(function () {
    var subscribe = elements.some(function (_ref2) {
      var shouldRender = _ref2.shouldRender,
          getButtonDisabledState = _ref2.getButtonDisabledState,
          shouldRenderCode = _ref2.shouldRenderCode;
      return Boolean(shouldRender) || Boolean(getButtonDisabledState) || Boolean(shouldRenderCode);
    });

    if (subscribe) {
      Array.isArray(subscribedFields) ? registerDependencies(subscribedFields, dispatch) : registerDependencies('SUBSCRIBE_ALL', dispatch);
    }

    var dependentField = [];
    elements.forEach(function (_ref3) {
      var asserts = _ref3.asserts;
      if (!(asserts === null || asserts === void 0 ? void 0 : asserts.length)) return;
      asserts.forEach(function (_ref4) {
        var field = _ref4.field;
        return dependentField.push(field);
      });
    });
    dependentField.length && registerDependencies(dependentField, dispatch);
  }, []);
  useEffect(function () {
    if (currentStep === undefined || currentStep === current) return;
    setCurrent(currentStep);
  }, [currentStep]);
  var renderElements = elements.filter(function (_ref5) {
    var type = _ref5.type,
        curName = _ref5.name,
        validationRule = _ref5.validationRule,
        dependencies = _ref5.dependencies,
        asserts = _ref5.asserts,
        shouldRender = _ref5.shouldRender,
        shouldRenderCode = _ref5.shouldRenderCode;
    invariant(type === 'Step', 'Child of steps should be Step');
    invariant(!validationRule || getRuleValidationApi, 'Please provide getRuleValidationApi in Form props');
    return calcShouldRender(calcNamePath(calcNamePath(parentName, name), curName), dependencies, asserts, shouldRender, shouldRenderCode, form);
  });

  var handleNext = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _allFields$filter;

      var allFields, allValues, _renderElements$curre, currentName, handleNext, validationRule, namePath, fields, _iterator, _step, collapseSection, res, errors;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              allFields = (form === null || form === void 0 ? void 0 : form.getFieldsError()) || [];
              allValues = form === null || form === void 0 ? void 0 : form.getFieldsValue(true);
              _renderElements$curre = renderElements[current], currentName = _renderElements$curre.name, handleNext = _renderElements$curre.handleNext, validationRule = _renderElements$curre.validationRule;
              namePath = calcNamePath(name, currentName);
              fields = allFields === null || allFields === void 0 ? void 0 : (_allFields$filter = allFields.filter(function (_ref7) {
                var name = _ref7.name;
                return name.join().startsWith(namePath === null || namePath === void 0 ? void 0 : namePath.join());
              })) === null || _allFields$filter === void 0 ? void 0 : _allFields$filter.map(function (_ref8) {
                var name = _ref8.name;
                return name;
              });
              _context.prev = 5;
              _context.next = 8;
              return form === null || form === void 0 ? void 0 : form.validateFields(fields);

            case 8:
              _context.next = 16;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](5);
              form === null || form === void 0 ? void 0 : form.scrollToField(_context.t0.errorFields[0].name);
              _iterator = _createForOfIteratorHelper(sections.current.values());

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  collapseSection = _step.value;
                  collapseSection(false);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              return _context.abrupt("return");

            case 16:
              if (!(validationRule && getRuleValidationApi)) {
                _context.next = 30;
                break;
              }

              _context.prev = 17;
              _context.next = 20;
              return getRuleValidation(getRuleValidationApi, validationRule, allValues, currentLang);

            case 20:
              res = _context.sent;

              if (!(Array.isArray(res) && res.length)) {
                _context.next = 25;
                break;
              }

              form === null || form === void 0 ? void 0 : form.setFields(res);
              form === null || form === void 0 ? void 0 : form.scrollToField(res[0].name);
              return _context.abrupt("return");

            case 25:
              _context.next = 30;
              break;

            case 27:
              _context.prev = 27;
              _context.t1 = _context["catch"](17);
              return _context.abrupt("return");

            case 30:
              if (!(typeof handleNext === 'function')) {
                _context.next = 42;
                break;
              }

              _context.prev = 31;
              _context.next = 34;
              return handleNext(form === null || form === void 0 ? void 0 : form.getFieldsValue(fields));

            case 34:
              errors = _context.sent;

              if (!Array.isArray(errors)) {
                _context.next = 37;
                break;
              }

              return _context.abrupt("return", form === null || form === void 0 ? void 0 : form.setFields(errors));

            case 37:
              _context.next = 42;
              break;

            case 39:
              _context.prev = 39;
              _context.t2 = _context["catch"](31);
              return _context.abrupt("return");

            case 42:
              setCurrent(last || current + 1);
              setLast(0);
              setShouldScroll(true);

            case 45:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 10], [17, 27], [31, 39]]);
    }));

    return function handleNext() {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleEdit = function handleEdit(index) {
    setLast(current);
    setCurrent(index);
    setShouldScroll(false);
    typeof onEdit === 'function' && onEdit(index);
  };

  var registerSection = function registerSection(name, toggle) {
    sections.current.set(name, toggle);
  };

  return _jsxs("div", {
    className: 'igloo-hsteps-container',
    children: [md && _jsxs("div", {
      className: 'igloo-hsteps-bar',
      children: [renderElements.map(function (step, index) {
        return _jsxs("div", {
          className: classNames({
            'igloo-hsteps-bar-item': true,
            'igloo-hsteps-bar-item-current': index === current
          }),
          style: {
            cursor: index < current ? 'pointer' : 'default'
          },
          onClick: function onClick() {
            if (index >= current) return;
            setCurrent(index);
          },
          children: [index < current && _jsx(SuccessFilled, {
            className: 'igloo-hsteps-bar-item-icon'
          }), _jsx(Typography, {
            level: "h3a",
            className: 'igloo-hsteps-bar-item-text',
            children: step.label
          })]
        });
      }), withReview && _jsxs("div", {
        className: classNames({
          'igloo-hsteps-bar-item': true,
          'igloo-hsteps-bar-item-current': current === renderElements.length
        }),
        children: [current === renderElements.length && _jsx(Radio, {
          checked: true
        }), _jsx(Typography, {
          level: "h3a",
          className: 'igloo-hsteps-bar-item-text',
          children: formatMessage({
            id: 'Review and Submit'
          })
        })]
      })]
    }), _jsxs("div", {
      className: "igloo-hsteps-content",
      children: [current < renderElements.length && _jsx(StepContext.Provider, {
        value: {
          registerSection: registerSection
        },
        children: _jsx(HStep, {
          config: renderElements[current],
          parentName: calcNamePath(parentName, name),
          index: current,
          total: withReview ? renderElements.length + 1 : renderElements.length,
          preview: false,
          edit: true,
          handleNext: handleNext,
          handleEdit: handleEdit,
          shouldScroll: shouldScroll
        }, ((_renderElements$curre2 = renderElements[current]) === null || _renderElements$curre2 === void 0 ? void 0 : _renderElements$curre2.key) || ((_renderElements$curre3 = renderElements[current]) === null || _renderElements$curre3 === void 0 ? void 0 : _renderElements$curre3.name))
      }), current === renderElements.length && _jsxs("div", {
        className: "igloo-hsteps-confirmation-container",
        children: [withReview && !md && _jsxs(Typography, {
          className: "igloo-hstep-label",
          level: "h3a",
          style: {
            display: 'flex',
            justifyContent: 'space-between'
          },
          children: [_jsx("span", {
            className: "igloo-hstep-label-text",
            children: formatMessage({
              id: 'Review and Submit'
            })
          }), _jsxs(Typography, {
            level: "body3",
            children: [renderElements.length + 1, "/", renderElements.length + 1]
          })]
        }), renderElements.map(function (step, index) {
          return _jsx(HStep, {
            config: step,
            parentName: calcNamePath(parentName, name),
            index: index,
            total: withReview ? renderElements.length + 1 : renderElements.length,
            preview: true,
            edit: false,
            handleNext: handleNext,
            handleEdit: handleEdit,
            shouldScroll: shouldScroll
          }, (step === null || step === void 0 ? void 0 : step.key) || (step === null || step === void 0 ? void 0 : step.name));
        }), _jsxs("div", {
          className: "igloo-hsteps-confirmation",
          children: [description || _jsxs(_Fragment, {
            children: [_jsx(Typography, {
              level: md ? 'h3a' : 'h4',
              wrapElement: "div",
              children: formatMessage({
                id: 'Review and Submit'
              })
            }), _jsx(Typography, {
              level: md ? 'h3b' : 'body1',
              style: {
                marginTop: 24
              },
              wrapElement: "div",
              children: formatMessage({
                id: 'Please take a moment to review what you’ve told us above.'
              })
            }), _jsx(Typography, {
              level: md ? 'h3b' : 'body2',
              style: {
                marginTop: 24
              },
              wrapElement: "div",
              children: formatMessage({
                id: 'Once you’re happy with the above, and you’ve checked the box below, please go ahead and submit your activation.'
              })
            })]
          }), _jsx(_Divider, {}), !confirmations && _jsx(_Form.Item, {
            name: calcNamePath(parentName, 'confirmation'),
            rules: [{
              validator: function validator(_, value) {
                if (!value) {
                  return Promise.reject(formatMessage({
                    id: 'Please read and agree to Igloo Terms of Use and Privacy Policy'
                  }));
                }

                return Promise.resolve();
              }
            }],
            style: {
              margin: 0
            },
            children: _jsx(Confirmation, {})
          }), confirmations && Object.entries(confirmations).map(function (_ref9) {
            var _ref10 = _slicedToArray(_ref9, 2),
                key = _ref10[0],
                _ref10$ = _ref10[1],
                required = _ref10$.required,
                _ref10$$confirmation = _ref10$.confirmation,
                confirmation = _ref10$$confirmation === void 0 ? {} : _ref10$$confirmation,
                requiredMessage = _ref10$.requiredMessage;

            return _jsx(_Form.Item, {
              name: calcNamePath(parentName, key),
              rules: [{
                validator: function validator(_, value) {
                  if (required && !value) {
                    return Promise.reject(requiredMessage || formatMessage({
                      id: 'Please read and agree to Igloo Terms of Use and Privacy Policy'
                    }));
                  }

                  return Promise.resolve();
                }
              }],
              style: {
                margin: 0
              },
              children: _jsx(Confirmation, _objectSpread({}, confirmation))
            });
          }), showSubmitButton && md && _jsx(_Form.Item, {
            style: {
              marginBottom: 0
            },
            className: "igloo-hsteps-button-container",
            children: _jsx(Button, {
              type: "primary",
              htmlType: "submit",
              className: 'igloo-hsteps-button',
              loading: submitting,
              children: submitText || formatMessage({
                id: 'Submit'
              })
            })
          })]
        })]
      })]
    }), showSubmitButton && current === renderElements.length && !md && _jsx(_Form.Item, {
      style: {
        marginBottom: 0
      },
      className: "igloo-hsteps-button-container",
      children: _jsx(Button, {
        type: "primary",
        htmlType: "submit",
        className: 'igloo-hsteps-button',
        loading: submitting,
        children: submitText || formatMessage({
          id: 'Submit'
        })
      })
    })]
  });
};

export default HSteps;